import { useCallback, useContext, useMemo } from 'react'
import { LayoutContext } from '../context'
import { setLayoutSidebarIsOpen } from '../context/actions'
import { useAuth } from '@modules/me/hooks'
import { MeService } from '../../me/services'
import { resetMeAction } from '../../me/context/actions'
import { message } from 'antd'
import { useBackgroundNavigate } from '@shared/hooks'

export const useHeader = () => {
  const { state: layout, dispatch: layoutDispatch } = useContext(LayoutContext)

  const { state: me, dispatch: meDispatch } = useAuth()
  const navigate = useBackgroundNavigate()

  const [firstName, lastName] = useMemo<[string, string]>(() => [me.user.data?.firstName || '', me.user.data?.lastName || ''], [me.user.data])

  const avatarText = useMemo<string>(() => firstName[0] + lastName[0], [firstName, lastName])

  const toggleSidebar = useCallback(() => {
    layoutDispatch(setLayoutSidebarIsOpen(!layout.sidebar.isOpen))
  }, [layoutDispatch, layout.sidebar.isOpen])

  const logout = useCallback(async () => {
    message.loading({ key: 'header-message', content: 'Əməliyyat aparılır...' })
    await MeService.logout()
    meDispatch(resetMeAction())
    navigate('/')
    message.destroy('header-message')
  }, [meDispatch, navigate])

  return { sidebarIsOpen: layout.sidebar.isOpen, toggleSidebar, avatarText, logout }
}
